<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="no-results">
    <slot name="title" />
    <slot name="text" />
    <slot name="action" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.no-results {
  margin: 0 auto;
  text-align: center;
  width: 80%;

  h1 {
    opacity: 0.5;
  }

  p {
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.116667px;
    line-height: 2.4rem;
    margin-bottom: 2rem;
  }
}
</style>
